var scope_0 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/051262de25806fcd6daa8ed803348543.js').default;
var scope_1 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0fcfc671160703384e74e9affb48dcff.js').default;
var scope_2 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/29cb735c87e868cdb1a2938d357cc7dc.js').default;
var scope_3 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2acf4a7a25a49d2df90f78494d0dbf4d.js').default;
var scope_4 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3d5a843bedaa60500b5979cc3c61d1ae.js').default;
var scope_5 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b57238e6f22a1b433147235d61b32c1b.js').default;
var scope_6 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c0c7de155cd7cebccfcc96ab062f8613.js').default;
var scope_7 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c4bfab42fadb3cf7ddf5c0a8441404dc.js').default;
var scope_8 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e1625f12d6ffbcc691da35d4921ede84.js').default;
var scope_9 = require('/app/sebdbdocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9 )
    